/**
 * @module menu
 * @description メニューの開閉制御
 * @example
 * import './menu.js';
 * @howtouse
 * <button id="menu-button" aria-controls="menu" aria-label="メニューを開く">メニューボタン</button>
 * <nav id="menu" aria-hidden="true">
 *   <ul>
 *     <li><a href="#">ホーム</a></li>
 *     <li><a href="#">メニュー</a></li>
 *   </ul>
 * </nav>
 */

// Utility functions
const $ = selector => document.querySelector(selector);
const $$ = selector => Array.from(document.querySelectorAll(selector));

// Menu
const menuButton = $('#menu-button');
const menu = $('#menu');

// メニュー内のフォーカス可能な要素を取得
const focusableElements = menu.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');

// メニューの状態を管理
let isMenuOpen = false;

// メニューの開閉を制御する関数
const toggleMenu = () => {
  isMenuOpen = !isMenuOpen;
  
  // WAI-ARIAの属性を更新
  menu.setAttribute('aria-hidden', !isMenuOpen);
  menuButton.setAttribute('aria-expanded', isMenuOpen);
  menuButton.setAttribute('aria-label', isMenuOpen ? 'メニューを閉じる' : 'メニューを開く');

  // メニューの表示/非表示を切り替え
  if (isMenuOpen) {
    menu.classList.remove('hidden');
    // 最初のフォーカス可能な要素にフォーカスを移動
    if (focusableElements.length) focusableElements[0].focus();
    $('body').classList.add('menu-open');
  } else {
    menu.classList.add('hidden');
    menuButton.focus();
    $('body').classList.remove('menu-open');
  }
};

// メニューボタンのクリックイベント
menuButton.addEventListener('click', toggleMenu);

// メディアクエリでPC/SP切り替え時の処理
const mediaQuery = window.matchMedia('(min-width: 960px)');

const handleMediaChange = (e) => {
  if (e.matches) {
    // PC表示の場合
    menu.classList.remove('hidden');
    menu.setAttribute('aria-hidden', 'false');
  } else {
    // SP表示の場合
    menu.classList.add('hidden');
    menu.setAttribute('aria-hidden', 'true');
    isMenuOpen = false;
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.setAttribute('aria-label', 'メニューを開く');
  }
};

mediaQuery.addListener(handleMediaChange);
handleMediaChange(mediaQuery);

// メニューのリンクをクリックしたときの処理
menu.addEventListener('click', (e) => {
  // メニューリンクまたはメニューエリア自体がクリックされた場合
  if (!mediaQuery.matches) {
    if (e.target.tagName === 'A' || e.target === menu) {
      toggleMenu();
    }
  }
});

// メニュー内でのキーボード操作
menu.addEventListener('keydown', (e) => {
  if (!isMenuOpen) return;

  const focusableArray = Array.from(focusableElements);
  const firstFocusable = focusableArray[0];
  const lastFocusable = focusableArray[focusableArray.length - 1];

  // ESCキーでメニューを閉じる
  if (e.key === 'Escape') {
    toggleMenu();
    return;
  }

  // TABキーでのフォーカス制御
  if (e.key === 'Tab') {
    if (e.shiftKey) {
      // Shift + TABで最初の要素にフォーカスがある場合、最後の要素にフォーカスを移動
      if (document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      }
    } else {
      // TABで最後の要素にフォーカスがある場合、最初の要素にフォーカスを移動
      if (document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  }
});
